import { IKeyedObject } from "@dirootie-extensions/typescript";
import { fromPairs, toPairs, curry, applySpec } from "ramda";
import { mapIndexed } from "ramda-adjunct";
import { di } from "@dirootie-core/di";
import { IRoute } from "./_types";

////Routes web
export const webRoutesCfg = {
  regex: /((:[^:/&?]*[/&?]{1})|(:[^=:]*$))/g,
  fromPlaceholder: [':', '?', '/', '&'],
  toPlaceHolder: (str: string) => `:${str}`,
};

///Routes api
const apiRoutesCfg = {
  regex: /(({[^{}?]*[}]{1}))/g,
  fromPlaceholder: ['{', '}'],
  toPlaceHolder: (str: string) => `{${str}}`,
};

export const hasPlaceholders = (regex: RegExp, template: string) =>
  regex.test(template);

export const createReplaceFn = (
  defs: typeof webRoutesCfg,
  template: string
) => {
  const matches = template.match(defs.regex);
  const params = fromPairs(
    mapIndexed(
      (x, index: number, a: any) =>
        [di.str.removeChar(defs.fromPlaceholder, x), index] as any,
      matches!
    )
  );
  const fn = (obj: IKeyedObject<any>) => {
    const toReplace = toPairs(obj).map<[string, string]>((x) => [
      defs.toPlaceHolder(x[0]),
      x[1],
    ]);
    const result = di.str.replaceAllList(toReplace, template);
    return result;
  };
  return { placeHolders: params, getTemplate: fn };
};

export const webRoute = curry(createReplaceFn)(webRoutesCfg);

export const apiRoute = curry(createReplaceFn)(apiRoutesCfg);

export const createRouteDescription = (route: {template:string,id:string}) => {
  const {template,id} = route;
  const hasPlaceHolders = hasPlaceholders(webRoutesCfg.regex, route.template);
  const templateData = hasPlaceHolders
    ? webRoute(template)
    : {
        placeHolders: [],
        getTemplate: () => template,
      };
  const routeDescription = {
    hasPlaceHolders,
    ...templateData,
    screenId: id,
  };
  return routeDescription;
};

export const buildEndpoint = applySpec({
  list: {
    template: (base: string) => `${base}`,
  },
  create: {
    template: (base: string) => `${base}`,
  },
  details: {
    template: (base: string) => `${base}/{id}`,
  },
  update: {
    template: (base: string) => `${base}/{id}`,
  },
  delete: {
    template: (base: string) => `${base}/{id}`,
  },
});
